import { Component } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LoyaltyProgram } from 'src/app/assabil-sales/models/entities/loyalty-program';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';



@Component({
  selector: 'loyalty-program-list',
  templateUrl: './loyalty-program-list.component.html',
  styleUrls: ['./loyalty-program-list.component.scss']
})
export class LoyaltyProgramListComponent extends BasePage2<LoyaltyProgram> {

  // Filter fields
  // -------------------------------------------------------------------------------------
  code: string;
  name: string;
  // -------------------------------------------------------------------------------------
      
  // -------------------------------------------------------------------------------------
  loyaltyPrograms: LoyaltyProgram[] = [];
  // -------------------------------------------------------------------------------------
  
  // -------------------------------------------------------------------------------------

  constructor(
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected loyaltyService    : LoyaltyService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "loyaltyProgram";
  }
  // -------------------------------------------------------------------------------------

  

//--------------------------------------------------------------------------------------------------------
getRows(): LoyaltyProgram[] {
      return this.loyaltyPrograms;
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
new(){
  let entity :  LoyaltyProgram = new LoyaltyProgram();
  entity.inserted = true;
  entity.edit     = true;
  this.loyaltyPrograms.push(entity);
  this.loyaltyPrograms = [...this.loyaltyPrograms];
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
saveRow(loyaltyProgram : LoyaltyProgram): Promise<LoyaltyProgram> {
  return this.loyaltyService.loyaltyProgramSave(loyaltyProgram);
}
//--------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------
loadData() {
  this.loyaltyService.loyaltyProgramsGet(this.code, this.name).then(result => {
      this.loyaltyPrograms = result;
  })
}
//--------------------------------------------------------------------------------------------------------

}
